import React, { useCallback } from 'react';
import { useTaskBank } from './use-task-bank';
import { Task } from '@/app/task-bank/public-actions';

interface UseEssayTaskBankProps {
  initialPrompt: string;
  setPrompt: React.Dispatch<React.SetStateAction<string>>;
}

export function useEssayTaskBank({
  initialPrompt,
  setPrompt,
}: UseEssayTaskBankProps) {
  const handleTaskSelected = useCallback(
    (task: Task) => {
      setPrompt(task.prompt);
    },
    [setPrompt]
  );

  const handlePromptChangedManually = useCallback(() => {
    // No action needed here now, useTaskBank handles its internal state
  }, []);

  const taskBank = useTaskBank({
    initialPrompt,
    onTaskSelected: handleTaskSelected,
    onPromptManuallyChanged: handlePromptChangedManually,
  });

  return {
    taskBank,
  };
}
